class LibraryPicksRepository {
  constructor(Fw5MLApi) {
    this.Fw5MLApi = Fw5MLApi
  }

  async getLibraryPicks({ companyId, per_page, page }) {
    const req = await this.Fw5MLApi.fetch(
      `/content/library-picks/${companyId}`,
      'POST',
      {
        per_page: per_page,
        page: page
      }
    )
    return req.data
  }

  async addLibraryPicks({ articleId, companyId, siteId }) {
    const req = await this.Fw5MLApi.fetch('/library_picks', 'POST', {
      article_id: parseInt(articleId),
      company_id: parseInt(companyId),
      site_id: parseInt(siteId)
    })
    return req.data
  }

  async removeLibraryPick(id) {
    const req = await this.Fw5MLApi.fetch(`/library_picks/${id}`, 'DELETE')
    return req
  }
}
export default LibraryPicksRepository
